import { ConnectionInfo, Device } from "../interfaces/EndpointInterfaces";
import { FaWindows, FaApple, FaLinux } from "react-icons/fa";



export const transformApiToDevicePerDevice = (item: any): Device => {
  return {
    id: String(item.id),
    name: item.dNSHostName || "Unknown",

    os: item.OperatingSystem || item.os || "Unknown",

    agentVersion: item.agentVersion || item.agentversion || "N/A",

    ipAddresses:
      item.IPV4Addresses && item.IPV4Addresses.length > 0
        ? item.IPV4Addresses
        : item.IPV4Address
          ? [item.IPV4Address]
          : [],

    tags: item.tags || [],
    profile: item.profile || "N/A",
    profileMode: item.profileMode || "",

    operatingMode:
      item.operatingMode?.toLowerCase() === "enforcing"
        ? "enforcing"
        : "auditing",

    mode: item.mode || "INHERITED_FROM_PROFILE",
    status: item.has_agent ? "online" : "offline",

    management: {
      publish: item.management?.publish ?? true,
      roles: item.management?.roles || [],
    },

    recording: item.recordingPathEnabled || false,
    guachost: item.guachost || "",
    has_agent: item.has_agent || false,
    accessRemainingTime: item.accessRemainingTime || "",
    whiteswanAccessGroupId: item.whiteswanAccessGroupId || "",

    agentversion: item.agentversion || "",
    OperatingSystem: item.OperatingSystem || "",
    IPV4Addresses: item.IPV4Addresses || [],
    IPV4Address: item.IPV4Address || "",

    isManuallyAddedMachine: item.isManuallyAddedMachine || false,
    belongedToUser: item.belongedToUser || "",
    isNebulaEnabled: item.isNebulaEnabled || false,
    friendlyName: item.friendlyName || "",
    accessPort: item.accessPort || 22,
    connectionCreatedFor: item.connectionCreatedFor?.map(
      (c: any): ConnectionInfo => ({
        userId: Number(c.userId),
        username: c.username || "",
        role: c.role || "",
        computerId: Number(c.computerId),
        accessPort: Number(c.accessPort),
      })
    ),
    categories: item.categories?.map((category: any) => ({
      categoryName: category.categoryName || "Unknown",
      uuid: category.uuid || "",
      reputationScore: category.reputationScore ?? 0,
      profileId: category.profileId ?? 0,
      profileName: category.profileName || "Unknown"
    })) || [],
    publishedroleIds: item.publishedroleIds || [],
    recordingPathEnabled: item.recordingPathEnabled || false,
    isGateway: item.isGateway || false,
    agentUpgradeAvailable: item.agentUpgradeAvailable || false,
    gatewayIpAddresses: item.gatewayIpAddresses || [],
    gatewayComputerId: item.gatewayComputerId || -1,
    protocol: item.protocol || "",
    dNSHostName: item.dNSHostName || "",
    lastSeen: item.lastSeen || "",
    isWhitewanAccess: item.isWhitewanAccess || "",
    isServer: item.isServer,
    hasAccess: item.hasAccess,
    userId: item.userId,
    isWhiteswanAccess: item.isWhiteswanAccess,
    defaultTime: item.defaultTime || 0

  };
};


export const transformApiToDevice = (apiDevices: any[]): Device[] => {
  return apiDevices.map((item: any): Device => ({
    id: String(item.id),
    name: item.dNSHostName || "Unknown",

    os: item.OperatingSystem || item.os || "Unknown",

    agentVersion: item.agentVersion || item.agentversion || "N/A",

    ipAddresses:
      item.IPV4Addresses && item.IPV4Addresses.length > 0
        ? item.IPV4Addresses
        : item.IPV4Address
          ? [item.IPV4Address]
          : [],

    tags: item.tags || [],
    profile: item.profile || "N/A",
    profileMode: item.profileMode || "",

    operatingMode:
      item.operatingMode?.toLowerCase() === "enforcing"
        ? "enforcing"
        : "auditing",

    mode: item.mode || "INHERITED_FROM_PROFILE",
    status: item.has_agent ? "online" : "offline",

    management: {
      publish: item.management?.publish ?? true,
      roles: item.management?.roles || [],
    },

    recording: item.recordingPathEnabled || false,
    guachost: item.guachost || "",
    has_agent: item.has_agent || false,
    accessRemainingTime: item.accessRemainingTime || "",
    whiteswanAccessGroupId: item.whiteswanAccessGroupId || "",

    agentversion: item.agentversion || "",
    OperatingSystem: item.OperatingSystem || "",
    IPV4Addresses: item.IPV4Addresses || [],
    IPV4Address: item.IPV4Address || "",

    isManuallyAddedMachine: item.isManuallyAddedMachine || false,
    belongedToUser: item.belongedToUser || "",
    isNebulaEnabled: item.isNebulaEnabled || false,
    friendlyName: item.friendlyName || "",
    accessPort: item.accessPort || 22,
    connectionCreatedFor: item.connectionCreatedFor?.map(
      (c: any): ConnectionInfo => ({
        userId: Number(c.userId),
        username: c.username || "",
        role: c.role || "",
        computerId: Number(c.computerId),
        accessPort: Number(c.accessPort),
      })
    ),
    categories: item.categories?.map((category: any) => ({
      categoryName: category.categoryName || "Unknown",
      uuid: category.uuid || "",
      reputationScore: category.reputationScore ?? 0,
      profileId: category.profileId ?? 0,
      profileName: category.profileName || "Unknown"
    })) || [],
    publishedroleIds: item.publishedroleIds || [],
    recordingPathEnabled: item.recordingPathEnabled || false,
    isGateway: item.isGateway || false,
    agentUpgradeAvailable: item.agentUpgradeAvailable || false,
    gatewayIpAddresses: item.gatewayIpAddresses || [],
    gatewayComputerId: item.gatewayComputerId || -1,
    protocol: item.protocol || "",
    dNSHostName: item.dNSHostName || "",
    lastSeen: item.lastSeen || "",
    isWhitewanAccess: item.isWhitewanAccess || "",
    isServer: item.isServer,
    hasAccess: item.hasAccess,
    userId: item.userId,
    isWhiteswanAccess: item.isWhiteswanAccess,
    defaultTime: item.defaultTime || 0,
    installTag: item.installTag || ""
  }));
};

export const getIsLinux = (osString: string) => {
  const os = osString.toLowerCase();
  if (os.includes("ubuntu") ||
    os.includes("centos") ||
    os.includes("rhel") ||
    os.includes("rocky") ||
    os.includes("linux")) {
    return true;
  }
  return false;
}

export const getOSIcon = (osString: string) => {
  const os = osString?.toLowerCase() || "";
  const sizeClass = "w-7 h-7";

  if (os.includes("windows"))
    return <FaWindows className={`${sizeClass} text-blue-600 dark:text-blue-400`} />;
  if (os.includes("mac") || os.includes("darwin"))
    return <FaApple className={`${sizeClass} text-gray-800 dark:text-white`} />;
  if (
    os.includes("ubuntu") ||
    os.includes("centos") ||
    os.includes("rhel") ||
    os.includes("rocky") ||
    os.includes("linux")
  )
    return <FaLinux className={`${sizeClass} text-black dark:text-white`} />;

  return <FaLinux className={`${sizeClass} text-gray-500 dark:text-gray-400`} />;
};


export interface Group {
  groupStatus: "ENABLED" | "DISABLED" | "DYNAMIC" | "INHERITED";
  inheritedGroupStatus?: "ENABLED" | "DISABLED" | "DYNAMIC";
  remainingTime?: number;
}

export const checkIfUserHasAccess = (group?: Group): boolean => {
  if (!group) return false;

  const hasAccess: Record<"ENABLED" | "DISABLED" | "DYNAMIC", boolean> = {
    ENABLED: true,
    DISABLED: false,
    DYNAMIC: group.remainingTime && group.remainingTime > 0 ? true : false,
  };

  const selectedGroupStatus =
    group.groupStatus !== "INHERITED"
      ? group.groupStatus
      : group.inheritedGroupStatus ?? "DISABLED";

  return hasAccess[selectedGroupStatus];
};


